import AdminQuestionsPracticeIndex from '@/pages/admin/questions/practice/Index'
import AdminQuestionsPracticeAdd from '@/pages/admin/questions/practice/Add'
import AdminQuestionsPracticeEdit from '@/pages/admin/questions/practice/Edit'

export default [
  {
    path: '/admin/questions/practice',
    name: 'AdminQuestionsPracticeIndex',
    component: AdminQuestionsPracticeIndex,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/practice/add',
    name: 'AdminQuestionsPracticeAdd',
    component: AdminQuestionsPracticeAdd,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/practice/edit/:id',
    name: 'AdminQuestionsPracticeEdit',
    component: AdminQuestionsPracticeEdit,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/questions/practice.js